import CollapseArrowIcon from "@assets/icons/collapseArrowIcon";
import { PolicyEnum } from "@config/policyEnum";
import { useHasPolicy } from "@config/useHasPolicy";
import {
  Box,
  Card,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";

interface ContactInformationProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: any;
  updateUserInfo: boolean;
  userData: any;
}

const ContactInformation: React.FC<ContactInformationProps> = ({
  handleChange,
  errors,
  updateUserInfo,
  userData,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showContactInformation, setShowContactInformation] = useState(true);

  const handleCollapse = () => {
    setShowContactInformation(!showContactInformation);
  };
  const showProfileContactNumber = useHasPolicy(PolicyEnum.VIEW_PROFILE_USER_CONTACT)
  const editProfileContactNumber = useHasPolicy(PolicyEnum.EDIT_PROFILE_USER_CONTACT); 

  return (
    <>
    {showProfileContactNumber &&
    <Card className="mt-4 md:mt-2 md:!shadow-none">
      <Box className=" hidden md:flex md:items-center bg-[#F2F2F2]">
        <Typography
          onClick={() => setShowContactInformation(true)}
          sx={{
            padding: "0.5rem 0.5rem 0.5rem 1rem",
            fontWeight: "500",
          }}
        >
          Contact Information
        </Typography>
      </Box>
      <Box
        className="flex justify-between items-center border-b-2 md:hidden"
        onClick={handleCollapse}
      >
        <Box className="flex items-center">
          <Typography
            sx={{
              padding: "0.5rem 0.5rem 0.5rem 1rem",
              backgroundColor: { xs: "#fff", sm: "#F2F2F2" },
              fontWeight: "400",
            }}
          >
            Contact Information
          </Typography>
        </Box>
        <Typography className="pr-3">
          <CollapseArrowIcon />
        </Typography>
      </Box>
      {(showContactInformation || !isMobile) && (
        <Box className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-4 gap-5 p-4 ">
          {showProfileContactNumber &&
          <Box className="flex flex-col">
            <Typography variant="body1">
              Primary Contact Number<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              required
              fullWidth
              name="contactNumber"
              placeholder="000 000 0000"
              size="small"
              value={userData?.contactNumber}
              onKeyDown={(e) => {
                if (
                  !/\d/.test(e.key) &&
                  e.key !== "Backspace" &&
                  e.key !== "Tab" &&
                  e.key !== "ArrowLeft" &&
                  e.key !== "ArrowRight"
                ) {
                  e.preventDefault();
                }
              }}
              onChange={handleChange}
              error={!!errors.contactNumber}
              helperText={errors.contactNumber}
              disabled={!updateUserInfo || !editProfileContactNumber}
            />
          </Box>}
        </Box>
      )}
    </Card>}
    </>
  );
};

export default ContactInformation;
